import React, { ChangeEvent, FC, useState, useRef, useEffect } from 'react';
import { FormGroup } from '../formInterfaces';
import { InputTitleStyled, StyledFormControl } from '../styled';

const EditInputForm: FC<Partial<FormGroup>> = ({ value, onChange }) => {
    const [widthValue, setWidthValue] = useState<string>('auto');
    const inputEl = useRef<HTMLInputElement>(null);
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange?.(e);
    };

    useEffect(() => {
        if (value && typeof value === 'string') {
            setWidthValue(`${value.length * 8}px`);
        }
    }, [value]);

    return (
        <StyledFormControl style={{ display: 'flex', flexDirection: 'row', gap: '8px', marginTop: '15px' }}>
            <InputTitleStyled
                id="title"
                inputRef={inputEl}
                onChange={handleChange}
                sx={{ width: widthValue }}
                value={value}
                multiline
            />
        </StyledFormControl>
    );
};

export default EditInputForm;
